import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import getAccountResponse from '@/types/responses/getAccount';
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountAutoComplete',
  props: {
    modelValue: {},
    operationOfficeId: {},
    operationOfficeOnly: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props

const items = ref<getAccountResponse[]>([]);
const searchText = ref('');

onMounted(() => {
  Api().autoCompleteAccounts(undefined).then((data) => {
    items.value = data;
  });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const normalize = (text: string) =>
  text.replace(/\s/g, '').replace(/\u3000/g, '').toLowerCase();

const filteredItems = computed(() => {
  let filteredItems = items.value

  if (props.operationOfficeOnly) {
    filteredItems = filteredItems.filter(item => {
      return item.operationOfficeId != null
    })
  }

  if (props.operationOfficeId) {
    resetModelValue()
    filteredItems = filteredItems.filter(item => {
      return item.operationOfficeId != null && item.operationOfficeId == props.operationOfficeId
    })
  }

  if (!searchText.value) {
    return filteredItems;
  }

  const query = normalize(searchText.value);
  return filteredItems.filter(item => normalize(item.name).includes(query));
});

function resetModelValue() {
  if (modelValue.value && modelValue.value?.operationOfficeId != props.operationOfficeId) {
    modelValue.value = undefined;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createBlock(_component_v_combobox, _mergeProps({
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    search: searchText.value,
    "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
    "custom-filter": () => true,
    label: _unref(i18n).global.t('pages.accounts.accountName'),
    "item-title": "name",
    "item-value": "id",
    items: filteredItems.value
  }, { 'return-object': true }), null, 16, ["modelValue", "search", "label", "items"]))
}
}

})